import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  // Show nothing while checking authentication
  if (loading) {
    return <div>Chargement...</div>;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check admin permission if required
  if (adminOnly && !user.isAdmin) {
    return <Navigate to="/" replace />;
  }

  
  return children;
};

export default PrivateRoute;
